'use client';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { forwardRef, useEffect, useRef, useState } from 'react';
import type { PhoneInputProps, CountryData } from 'react-international-phone';
import { PhoneInput, defaultCountries } from 'react-international-phone';
import './phone-input-styles.css';

export const PhoneInputField = forwardRef(
  ({
    className,
    variant,
    ...props
  }: PhoneInputProps & {
    variant?: 'outlined' | 'default';
  }) => {
    const [focused, setFocused] = useState(false);
    const phoneInputRef = useRef(null);

    const customCountries = defaultCountries.map(country => {
      if (country[0] === 'Slovakia') {
        return ['Slovakia', 'sk', '421', '... ... ...'] as CountryData;
      }
      return country;
    });

    const locale = useLocaleStore(s => s.currentLocale);

    const defaultCountryFromLocale = () => {
      if (locale === 'cs') {
        return 'cz';
      }
      return locale;
    };

    useEffect(() => {
      const handleClickOutside = (event: any) => {
        const current = phoneInputRef.current as any;
        if (current && !current.contains(event.target)) {
          setFocused(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [phoneInputRef]);

    return (
      <div
        ref={phoneInputRef}
        className={cn(
          'rounded-[10px]',
          variant === 'outlined' ? 'border border-border' : 'border border-black/10',
          focused && 'outline outline-1 outline-primary',
          className,
        )}
      >
        <PhoneInput
          defaultCountry={defaultCountryFromLocale()}
          name="phone"
          countries={customCountries}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          inputClassName={cn(
            'react-international-phone-input bg-white !important',
            'h-12 w-full rounded-r-[10px] border-none pl-5',
          )}
          countrySelectorStyleProps={{
            buttonClassName: cn(
              'react-international-phone-country-selector-button bg-white !important',
              'h-12 rounded-l-[10px]',
            ),
            buttonStyle: {
              height: '48px',
              backgroundColor: 'white',
              borderStartStartRadius: '10px',
              borderEndStartRadius: '10px',
              paddingLeft: '12px',
              border: 'none',
            },
          }}
          {...props}
        />
      </div>
    );
  },
);

PhoneInputField.displayName = 'PhoneInputField';
